import React from "react";

const GoogleGuide = () => {
  return (
    <div>
      Google Like A Pro Guide
      <br />
      <br />
      guide coming soon...maybe :)
      <br />
      <br />
      Please don't mind the simple design interface :)
      <br />
      <br />
      <strong>The aim</strong> of this web tool is to help narrow down your
      google search in order to get better results. It might take some time
      getting use to it. <br />
      <br />
      This tool was inspired by a tech youtube video made by FireShip on how to
      google like a pro.{" "}
      <a href="https://youtu.be/cEBkvm0-rg0">Click here to watch video</a>
      <br />
      <br />
      Seeing that it would a hassle to memorize all the operators mentioned in
      the video, this tool was created to solve that problem.
      <br />
      <br />
      <strong>quick note:</strong> focus on the search box after a previous
      search by clicking/tapping on it to return that previous search and clear
      the search input containing your specifiers/operators. Although, this
      should happen automatically.
    </div>
  );
};

export default GoogleGuide;
